import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BUSINESS } from "../constants/business";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white px-6 md:px-12 lg:px-24 py-24" data-testid="privacy-page">
      <div className="max-w-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-[#FF3B30] text-sm uppercase tracking-[0.15em] transition-colors duration-200" data-testid="privacy-back-link">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
        <h1 className="mt-10 font-oswald font-bold uppercase tracking-tight text-4xl sm:text-5xl">Privacy Policy</h1>
        <p className="mt-2 text-zinc-500 text-sm">Last updated: July 2026</p>

        <div className="mt-10 space-y-8 text-zinc-300 text-sm md:text-base leading-relaxed">
          <section>
            <h2 className="font-oswald uppercase tracking-wide text-xl text-white mb-3">Information We Collect</h2>
            <p>
              When you submit a service request, we collect the information you provide: your name,
              phone number, email address, vehicle details (year, make, model, engine, VIN, mileage),
              a description of the problem, and any photos you choose to upload.
            </p>
          </section>
          <section>
            <h2 className="font-oswald uppercase tracking-wide text-xl text-white mb-3">How We Use It</h2>
            <p>
              We use this information only to respond to your service request, diagnose your vehicle's
              issue, and communicate with you about your repair. We do not sell, rent, or share your
              personal information with third parties for marketing purposes.
            </p>
          </section>
          <section>
            <h2 className="font-oswald uppercase tracking-wide text-xl text-white mb-3">Photos &amp; Data Storage</h2>
            <p>
              Photos you upload are stored securely and accessed only by {BUSINESS.name} staff in
              connection with your service request. Service request records may be retained for our
              business records and future service history.
            </p>
          </section>
          <section>
            <h2 className="font-oswald uppercase tracking-wide text-xl text-white mb-3">Third-Party Services</h2>
            <p>
              This site embeds Google Maps to show our location. Google's privacy policy applies to
              that embedded content.
            </p>
          </section>
          <section>
            <h2 className="font-oswald uppercase tracking-wide text-xl text-white mb-3">Contact</h2>
            <p>
              Questions about this policy? Email us at{" "}
              <a href={`mailto:${BUSINESS.email}`} className="text-[#FF3B30] hover:underline">{BUSINESS.email}</a>{" "}
              or visit us at {BUSINESS.street}, {BUSINESS.city}.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
